<template>
<el-container style="height: 100%; border: 1px solid #eee;">
  <el-header style="font-size: 20px">
    <el-row>
      <el-col style="text-align: center; width: 90%;">
        <span>Visual Metaphor in Data Visualization</span>
      </el-col>
      <el-col style="text-align: right; width: 10%;">
        <el-button type="primary" @click="showMode = (showMode === 'list')?'drawer':'list'" circle icon="el-icon-refresh" style="margin-right: 5px;"></el-button>
        <StatTable @dbclick="handleTableDblclick"></StatTable>
      </el-col>
    </el-row>
  </el-header>
  <el-container style="overflow: hidden;">
    <el-aside width="15%" style="background-color: rgb(238, 241, 246); padding: 30px;">
      <!-- add an input and a button to enter query -->
      <div style="margin-bottom: 5px;">
        <span>根据需求检索 </span>
        <i class="el-icon-loading" v-if="waitingRec"></i>
      </div>
      <!-- <el-input placeholder="请输入关键字" v-model="query" style="margin-bottom: 10px;"></el-input> -->
      <el-input placeholder="请输入设计需求" v-model="query" type="textarea" :rows="10" style="margin-bottom: 10px;"></el-input>
      <div style="margin-bottom: 5px;">
        <span>可视化类型检索</span>
      </div>
      <el-input placeholder="请输入关键字" v-model="visQuery" style="margin-bottom: 10px;"></el-input>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="info" @click="reset">重置</el-button>
      <div v-if="showMode === 'list'">
        <div v-for="dim in rootKeys" :key="dim" style="margin-top: 10px;">
          <div>{{ rootNames[dim] }}</div>
          <el-cascader :options="dim in space?space[dim]:[]" :show-all-levels="false" clearable filterable
          :props="{ multiple: true }" @change="(v)=>handleChange(v, dim)" style="margin-top: 10px; margin-bottom: 10px; width: 90%;">
            <template slot-scope="{ node, data }">
              <span>{{ data.label }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
        </div>
        <div>
          <el-button type="warning" @click="filterFlags" style="margin-top: 10px;">筛选标记</el-button>
          <el-button type="warning" @click="filterStars" style="margin-top: 10px;">筛选收藏</el-button>
        </div>
        <div>
          <el-button type="danger" @click="filterUnAnno" style="margin-top: 10px;">筛未标注</el-button>
          <el-button type="info" @click="updateCards" style="margin-top: 10px;">显示选择</el-button>
        </div>
      </div>
    </el-aside>
    <el-container>
      <el-main style="overflow: hidden; padding: 0px;">
        <el-col v-if="showMode === 'list'" style="height: 100%;">
          <el-row style="padding: 10px; background-color: rgb(238, 241, 246);">
            <div style="padding-left: 10px;">
              <!-- <h1>Count: {{ showCount }}; Labeled: {{ labelCount }}; Flagged: {{ flagCount }}</h1> -->
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total, sizes, prev, next, ->, prev, pager, next, jumper"
                :total="showCount">
              </el-pagination>
            </div>
          </el-row>

          <el-row style="overflow-y: auto; height: calc(100% - 60px); padding-left: 20px;">
              <ImageCard v-for="card in reorderedCards" :key="card.name" :ref="'card_'+card.name"
                :buttonList="['recommend', 'star', 'edit', 'delete']" :cardInit="card"
                @recommend="recommendByImage" @delete="handleDelete">
              </ImageCard>
          </el-row>
        </el-col>
        <el-col v-if="showMode === 'drawer'" style="height: 100%;">
          <Drawers :data="drawerData" @recommend="recommendByImage"></Drawers>
        </el-col>
        <el-col v-if="showMode === 'treemap'" style="height: 100%;">
          <Treemap :data="treemapData"></Treemap>
        </el-col>
        <el-col v-if="showMode === 'recommend'" style="height: 100%;">
          <el-row style="padding: 10px; background-color: rgb(238, 241, 246);">
            <div style="padding-left: 10px;">
              <el-button @click="showMode = 'drawer'" plain size="mini">
                <i class="el-icon-arrow-left"></i>
                Back
              </el-button>
            </div>
          </el-row>
          <el-row style="height: calc(100% - 60px); padding-left: 20px;">
            <el-col :span="8" style="overflow: hidden; padding-top: 20px;">
              <ImageExplained @recommend="recommendByImage"
                  style="width: 500px; height: 200px; display: inline-block; margin: 5px;"
                  :cardInit="recommendCards[0]"
                />
            </el-col>
            <el-col style="overflow-y: auto; height: 100%;" :span="16">
              <ImageExplained @recommend="recommendByImage"
                  style="width: 500px; height: 200px; display: inline-block; margin: 5px;"
                  v-for="card in recommendCards.slice(1)"
                  :key="card.name + card.how"
                  :cardInit="card"
                />
            </el-col>
          </el-row>
        </el-col>
      </el-main>
      <!-- <el-footer style="height: 20%;">
        <el-col style="height: 100%; display: flex;">
          <el-image v-for="name in stars" :key="name" :src="imageUrl(name)" fit="cover" style="height: 100%; aspect-ratio: 1/1;">
            <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i>
              Loading<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </el-col>
      </el-footer> -->
    </el-container>
  </el-container>
  <!-- 删除前确认 -->
  <el-dialog
    title="提示"
    :visible.sync="deleteDialogVisible"
    width="30%">
    <span>确认要删除 {{ deleteName }} 吗？</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="deleteDialogVisible = false">取 消</el-button>
      <el-button type="danger" @click="doDelete">确 定</el-button>
    </span>
  </el-dialog>
</el-container>
</template>

<style>
  .el-header {
    background-color: #d7dee7;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
</style>

<script>
import axios from 'axios';
import ImageCard from '../components/ImageCard.vue';
import ImageExplained from '../components/ImageExplained.vue';
import StatTable from '../components/StatTable.vue';
import Treemap from '../components/Treemap.vue';
import Drawers from '../components/Drawers.vue';
export default {
    components: {
      ImageCard,
      ImageExplained,
      StatTable,
      Treemap,
      Drawers,
    },
    data() {
      const rootNames = {
        // 'What-yukai': 'What (隐喻的本体by yukai)',
        // 'What-jiashu': 'What (隐喻的本体by jiashu)',
        'Why': 'Why (隐喻的目的)',
        'What': 'What (隐喻的本体，数据语义)',
        'How': 'How (隐喻喻体的映射方式)',
        // 'How': 'How (隐喻的映射方式by yukai)',
        // 'How-jiashu': 'How (隐喻的映射方式by jiashu)',
        // 'How-liduan': 'How (隐喻的映射方式by liduan)',
        // 'How-lizhen': 'How (隐喻的映射方式by lizhen)',
        // 'How1': 'How1 (隐喻的内部关联模式)',
        // 'How2': 'How2 (隐喻的视觉设计模式)',
      }
      return {
        allCards: [],
        reorderedCards: [],
        coding: {},
        space: {},
        rootNames: rootNames,
        rootKeys: Object.keys(rootNames),
        select: {},
        currentPage: 1,
        pageSize: 5,
        query: '我现在手头上有一些碳排放的数据，大概是每个国家的数据，我想做一个带有视觉隐喻的信息图表，我的设计目的是为了引起大家对碳排放增加的关注。',
        visQuery: 'bar chart',
        showMode: 'list',
        treemapData: {children: []},
        drawerData: [],
        waitingRec: false,
        recommendCards: [],
        deleteDialogVisible: false,
        deleteName: '',
      }
    },
    computed: {
      showCount() {
        return this.allCards.filter(card => card.show).length;
      },
      labelCount() {
        return this.allCards.filter(card => card.show && card.design['What'][0].length > 0).length;
      },
      flagCount() {
        return this.allCards.filter(card => card.show && card.flagged).length;
      },
      stars() {
        return this.allCards.filter(card => card.show && card.starred).map(card => card.name);
      },
    },
    methods: {
      imageUrl(name, thumb=0) {
        return '/api/image?name=' + name + (thumb ? '&thumb=1' : '');
      },
      recommendByImage(name, cd={}) {
        const that = this;
        if (this.showMode === 'list') {
          axios.post('/rec/recommend', {name: name}).then(function(response) {
            let imageNames = response.data.names;
            console.log(imageNames);
            for (const card of that.allCards) {
              card.show = imageNames.includes(card.name);
            }
            let tmp = []
            for (const name of imageNames) {
              for (const card of that.allCards) {
                if (card.name === name) {
                  tmp.push(card);
                  break;
                }
              }
            }
            that.reorderedCards = tmp;
            that.updateCards();
          });
        }
        else {
          axios.post('/rec/recommend2', {name: name, card: cd}).then(function(response) {
            that.recommendCards = response.data;
            that.showMode = 'recommend';
          });
        }
      },
      search() {
        const that = this;
        if (that.query === '' && that.visQuery === '') {
          that.$message({
            message: '请输入关键字',
            type: 'warning',
            duration: 3000,
          });
          return;
        }
        if (this.showMode === 'list') {
          axios.post('/rec/search', {query: that.query, visQuery: that.visQuery}).then(function(response) {
            let imageNames = response.data.names;
            console.log(imageNames);
            for (const card of that.allCards) {
              card.show = imageNames.includes(card.name);
            }
            let tmp = []
            for (const name of imageNames) {
              for (const card of that.allCards) {
                if (card.name === name) {
                  tmp.push(card);
                  break;
                }
              }
            }
            that.reorderedCards = tmp;
            that.updateCards();
          });
        } else if (this.showMode === 'treemap') {
          axios.post('/rec/treemap', {query: that.query, visQuery: that.visQuery}).then(function(response) {
            that.treemapData = response.data;
          });
        } else if (this.showMode === 'drawer') {
          this.waitingRec = true;
          axios.post('/rec/drawers', {query: that.query, visQuery: that.visQuery}).then(function(response) {
            that.$message({
              message: '搜索成功',
              type: 'success',
              duration: 3000,
            });
            that.drawerData = response.data;
            that.waitingRec = false;
          });
        }
      },
      reset() {
        this.query = '';
        this.visQuery = '';
        this.reorderedCards = this.allCards;
        this.updateCards();
      },
      updatePageShow() {
        // set all pageshow to false
        for (const card of this.allCards) {
          card.pageShow = false;
        }
        let showCards = this.reorderedCards.filter(card => card.show);
        // set pageshow to true
        for (let i = (this.currentPage-1)*this.pageSize; i < this.currentPage*this.pageSize && i < showCards.length; i++) {
          showCards[i].pageShow = true;
        }
      },
      handleDelete(name) {
        this.deleteName = name;
        this.deleteDialogVisible = true;
      },
      doDelete() {
        const that = this;
        axios.post('/api/imagedelete', {name: that.deleteName}).then(function(response) {
          if (response.data.success) {
            that.$message({
                message: '删除成功',
                type: 'success',
                duration: 3000,
            });
            that.allCards = that.allCards.filter(card => card.name !== that.deleteName);
            that.reorderedCards = that.reorderedCards.filter(card => card.name !== that.deleteName);
          } else {
            that.$message({
                message: '删除失败: ' + response.data.message,
                type: 'error',
                duration: 3000,
            });
          }
          that.deleteDialogVisible = false;
          that.deleteName = '';
        });
      },
      handleSizeChange(val) {
        // console.log(`size change: ${val}`);
        this.pageSize = val;
        this.updatePageShow();
      },
      handleCurrentChange(val) {
        // console.log(`current change: ${val}`);
        this.currentPage = val;
        this.updatePageShow();
      },
      updateCards() {
        for (const card of this.reorderedCards) {
          let fir = true;
          let recList = [];
          for (const dim in this.select) {
            if (this.select[dim].length > 0) {
              let find = [];
              for (const v of this.select[dim]) {
                for (const di in card.design[dim]) {
                  if (card.design[dim][di] === this.catNames[v]) {
                    if (fir || recList.includes(di)) {
                      find.push(di);
                    }
                  }
                }
              }
              fir = false;
              recList = find;
            }
          }
          if (recList.length > 0 || fir) {
            card.show = true;
          } else {
            card.show = false;
          }
        }
        this.currentPage = 1;
        this.updatePageShow();
      },
      handleChange(value, dim) {
        // console.log(value, dim);
        this.select[dim] = value.map(v => v[v.length - 1]);
        // console.log(this.select);
        this.updateCards();
      },
      handleTableDblclick(why_name, what_name, how_name) {
        this.reorderedCards = this.allCards;
        for (const card of this.reorderedCards) {
          const l = card.design['Why'].length;
          card.show = false;
          for (let i = 0; i < l; i++) {
            if (card.design['Why'][i] === why_name &&
                card.design['What'][i] === what_name &&
                (how_name===''||card.design['How'][i] === how_name)) {
              card.show = true;
              break;
            }
          }
        }
        this.currentPage = 1;
        this.updatePageShow();
      },
      filterFlags() {
        for (const card of this.allCards) {
          if (card.show) {
            card.show = card.flagged;
          }
        }
        this.currentPage = 1;
        this.updatePageShow();
      },
      filterStars() {
        for (const card of this.allCards) {
          if (card.show) {
            card.show = card.starred;
          }
        }
        this.currentPage = 1;
        this.updatePageShow();
      },
      filterUnAnno() {
        for (const card of this.allCards) {
          if (card.show) {
            card.show = card.design['What'][0].length === 0;
          }
        }
        this.currentPage = 1;
        this.updatePageShow();
      },
    },
    mounted() {
      const that = this;
      axios.post('/api/metadata', {}).then(function(response) {
        console.log(response.data);
        let imageNames = response.data.images;
        that.coding = response.data.coding;
        that.space = response.data.space;
        that.catNames = response.data.names;
        let flags = response.data.flags;
        let stars = response.data.stars;
        that.allCards = imageNames.map(function(name) {
          return {name: name, design: that.coding[name], 
            flagged: flags.includes(name), starred: stars.includes(name),
            show: true, pageShow: false};
        });
        that.reorderedCards = that.allCards;
        that.updatePageShow();
      });
    }
  };
</script>